<template>
  <v-row v-if="domainLoaded && domain.load_error">
    <v-col>
      <gg-card>
        <gg-card-header>
          Error
        </gg-card-header>
        <gg-card-text>
          {{ domain.load_error }}
        </gg-card-text>
      </gg-card>
    </v-col>
  </v-row>
  <div v-else-if="isWhoisAvailable">
    <!--Registrant details-->
    <v-row>
      <v-col cols="12">
        <gg-card>
          <gg-card-header>
            <v-row>
              <v-col cols="6">
                Registrant Details
              </v-col>
              <v-col cols="6" class="text-right">
                <gg-btn v-show="!saveButtons.registrant" @click="saveButtons.registrant = true">
                  Edit
                </gg-btn>
              </v-col>
            </v-row>
          </gg-card-header>
          <gg-card-text>
            <v-row>
              <v-col cols="12" lg="7" xl="5">
                <v-sheet>
                  <v-row class="pt-3">
                    <v-col cols="12" sm="6" md="6" class="py-0">
                      <gg-text-field
                        outlined
                        label="First name"
                        v-model="model.registrant.FirstName"
                        :disabled="!saveButtons.registrant"
                      />
                    </v-col>
                    <v-col cols="12" sm="6" md="6" class="py-0">
                      <gg-text-field
                        outlined
                        label="Last name"
                        v-model="model.registrant.LastName"
                        :disabled="!saveButtons.registrant"
                      />
                    </v-col>
                    <v-col cols="12" sm="6" md="12" class="py-0">
                      <gg-text-field
                        outlined
                        label="Organization name"
                        v-model="model.registrant.OrganizationName"
                        :disabled="!saveButtons.registrant"
                      />
                    </v-col>
                    <v-col cols="12" sm="6" md="12" class="py-0">
                      <gg-text-field
                        outlined
                        label="Job title"
                        v-model="model.registrant.JobTitle"
                        :disabled="!saveButtons.registrant"
                      />
                    </v-col>
                    <v-col cols="12" sm="6" md="12" class="py-0">
                      <gg-text-field
                        outlined
                        label="Email"
                        v-model="model.registrant.EmailAddress"
                        :disabled="!saveButtons.registrant"
                      />
                    </v-col>
                    <v-col cols="12" sm="6" md="12" class="py-0">
                      <gg-text-field
                        outlined
                        label="Address line 1"
                        v-model="model.registrant.Address1"
                        :disabled="!saveButtons.registrant"
                      />
                    </v-col>
                    <v-col cols="12" sm="6" md="12" class="py-0">
                      <gg-text-field
                        outlined
                        label="Address line 2"
                        v-model="model.registrant.Address2"
                        :disabled="!saveButtons.registrant"
                      />
                    </v-col>
                    <v-col cols="12" sm="6" md="4" class="py-0">
                      <gg-text-field
                        outlined
                        label="City"
                        v-model="model.registrant.City"
                        :disabled="!saveButtons.registrant"
                      />
                    </v-col>
                    <v-col cols="12" sm="6" md="4" class="py-0">
                      <gg-text-field
                        outlined
                        label="State/Province"
                        v-model="model.registrant.StateProvince"
                        :disabled="!saveButtons.registrant"
                      />
                    </v-col>
                    <v-col cols="12" sm="6" md="4" class="py-0">
                      <gg-text-field
                        outlined
                        label="Zip"
                        v-model="model.registrant.PostalCode"
                        :disabled="!saveButtons.registrant"
                      />
                    </v-col>
                    <v-col cols="12" sm="6" md="12" class="py-0">
                      <gg-select
                        outlined
                        label="Country"
                        v-model="model.registrant.Country"
                        :value="model.registrant.Country"
                        :items="countries"
                        item-text="name"
                        item-value="code"
                        :disabled="!saveButtons.registrant"
                      >
                        <template slot="item" slot-scope="{ item }">
                          {{ item.code }} - {{ item.name }}
                        </template>
                        <template slot="selection" slot-scope="{ item }">
                          {{ item.code }} - {{ item.name }}
                        </template>
                      </gg-select>
                    </v-col>
                    <v-col cols="12" md="8" class="py-0">
                      <v-row no-gutters>
                        <v-col cols="12">
                          <gg-input-label>Phone</gg-input-label>
                        </v-col>
                        <v-col cols="4" class="pr-5">
                          <v-combobox
                            outlined
                            dense
                            name="suffix"
                            autocomplete="suffix"
                            v-model="model.registrant_country_code"
                            auto-select-first
                            :items="dialCodes"
                            :disabled="!saveButtons.registrant"
                          />
                        </v-col>
                        <v-col cols="8" class="d-flex flex-column">
                          <gg-text-field
                            class="mt-auto"
                            v-model="model.registrant.Phone"
                            required
                            name="Phone"
                            :disabled="!saveButtons.registrant"
                          />
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" md="8" class="py-0">
                      <v-row no-gutters>
                        <v-col cols="12">
                          <gg-input-label>Fax</gg-input-label>
                        </v-col>
                        <v-col cols="4" class="pr-5">
                          <v-combobox
                            outlined
                            dense
                            name="suffix"
                            autocomplete="suffix"
                            v-model="model.registrant_fax_country_code"
                            auto-select-first
                            :items="dialCodes"
                            :disabled="!saveButtons.registrant"
                          />
                        </v-col>
                        <v-col cols="8" class="d-flex flex-column">
                          <gg-text-field
                            class="mt-auto"
                            v-model="model.registrant.fax"
                            required
                            name="Fax"
                            :disabled="!saveButtons.registrant"
                          />
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-sheet>
              </v-col>
            </v-row>
          </gg-card-text>
        </gg-card>
      </v-col>
      <v-col v-show="saveButtons.registrant" cols="12">
        <gg-btn
          :loading="buttons.save"
          @click="openLockModal"
        >
          Save
        </gg-btn>
      </v-col>
    </v-row>

    <!-- International Domains -->
    <v-row v-if="domainPopulated && isAttributes">
      <v-col cols="12">
        <gg-card>
          <gg-card-header>
            <v-row>
              <v-col cols="6">
                Domain Attributes
              </v-col>
              <v-col cols="6" class="text-right">
                <gg-btn v-show="!saveButtons.domain" @click="saveButtons.domain = true">
                  Edit
                </gg-btn>
              </v-col>
            </v-row>
          </gg-card-header>
          <gg-card-text>
            <v-row>
              <v-col cols="12" lg="7" xl="5">
                <v-sheet>
                  <v-form>
                    <div
                      v-for="(attribute, key) in domain.ExtAttributes.Attribute"
                      :key="`attribute-${key}`">
                      <component :is="defineAttributeComponent(attribute)"
                                 v-if="attrsVisibility[attribute.Name] && isEditableAttribute(attribute)"
                                 outlined
                                 :name="attribute.Name"
                                 v-model="model.attributes[attribute.Name]"
                                 return-object
                                 :label="getAttributeLabel(attribute)"
                                 :items="resolveItems(attribute.Options.Option)"
                                 true-value="Y"
                                 false-value="N"
                                 @change="computeAttributes"
                                 v-validate="attributeValidationRules(attribute)"
                                 :error-messages="errors.collect(attribute.Name)"
                                 item-text="Title"
                                 item-value="Value"
                                 :disabled="!saveButtons.domain"
                      >
                      </component>
                    </div>
                  </v-form>
                </v-sheet>
              </v-col>
            </v-row>
          </gg-card-text>
        </gg-card>
      </v-col>
      <v-col v-show="saveButtons.domain" cols="12">
        <gg-btn
          :loading="buttons.save"
          @click="openLockModal"
        >
          Save
        </gg-btn>
      </v-col>
    </v-row>

    <!--Technical details-->
    <v-row>
      <v-col cols="12">
        <gg-card>
          <gg-card-header>
            <v-row>
              <v-col cols="6">
                Technical Details
              </v-col>
              <v-col cols="6" class="text-right">
                <gg-btn v-show="!saveButtons.tech" @click="saveButtons.tech = true">
                  Edit
                </gg-btn>
              </v-col>
            </v-row>
          </gg-card-header>
          <gg-card-text @input="listenTech">
            <v-col cols="12" lg="7" xl="5">
              <v-sheet class="pt-3">
                <v-form>
                  <v-row>
                    <v-col cols="12" sm="6" md="6" class="py-0">
                      <gg-text-field
                        outlined
                        label="First name"
                        v-model="model.tech.FirstName"
                        :disabled="!saveButtons.tech"
                      />
                    </v-col>
                    <v-col cols="12" sm="6" md="6" class="py-0">
                      <gg-text-field
                        outlined
                        label="Last name"
                        v-model="model.tech.LastName"
                        :disabled="!saveButtons.tech"
                      />
                    </v-col>
                    <v-col cols="12" sm="6" md="12" class="py-0">
                      <gg-text-field
                        outlined
                        label="Organization name"
                        v-model="model.tech.OrganizationName"
                        :disabled="!saveButtons.tech"
                      />
                    </v-col>
                    <v-col cols="12" sm="6" md="12" class="py-0">
                      <gg-text-field
                        outlined
                        label="Job title"
                        v-model="model.tech.JobTitle"
                        :disabled="!saveButtons.tech"
                      />
                    </v-col>
                    <v-col cols="12" sm="6" md="12" class="py-0">
                      <gg-text-field
                        outlined
                        label="Email"
                        v-model="model.tech.EmailAddress"
                        :disabled="!saveButtons.tech"
                      />
                    </v-col>
                    <v-col cols="12" sm="6" md="12" class="py-0">
                      <gg-text-field
                        outlined
                        label="Address line 1"
                        v-model="model.tech.Address1"
                        :disabled="!saveButtons.tech"
                      />
                    </v-col>
                    <v-col cols="12" sm="6" md="12" class="py-0">
                      <gg-text-field
                        outlined
                        label="Address line 2"
                        v-model="model.tech.Address2"
                        :disabled="!saveButtons.tech"
                      />
                    </v-col>
                    <v-col cols="12" sm="6" md="4" class="py-0">
                      <gg-text-field
                        outlined
                        label="City"
                        v-model="model.tech.City"
                        :disabled="!saveButtons.tech"
                      />
                    </v-col>
                    <v-col cols="12" sm="6" md="4" class="py-0">
                      <gg-text-field
                        outlined
                        label="State/Province"
                        v-model="model.tech.StateProvince"
                        :disabled="!saveButtons.tech"
                      />
                    </v-col>
                    <v-col cols="12" sm="6" md="4" class="py-0">
                      <gg-text-field
                        outlined
                        label="Zip"
                        v-model="model.tech.PostalCode"
                        :disabled="!saveButtons.tech"
                      />
                    </v-col>
                    <v-col cols="12" sm="6" md="12" class="py-0">
                      <gg-select
                        outlined
                        label="Country"
                        v-model="model.tech.Country"
                        :items="countries"
                        item-text="name"
                        item-value="code"
                        :disabled="!saveButtons.tech"
                      >
                        <template slot="item" slot-scope="{ item }">
                          {{ item.code }} - {{ item.name }}
                        </template>
                        <template slot="selection" slot-scope="{ item }">
                          {{ item.code }} - {{ item.name }}
                        </template>
                      </gg-select>
                    </v-col>
                    <v-col cols="12" md="8" class="py-0">
                      <v-row no-gutters>
                        <v-col cols="12">
                          <gg-input-label>Phone</gg-input-label>
                        </v-col>
                        <v-col cols="4" class="pr-5">
                          <v-combobox
                            outlined
                            dense
                            name="suffix"
                            autocomplete="suffix"
                            v-model="model.tech_country_code"
                            auto-select-first
                            :items="dialCodes"
                            :disabled="!saveButtons.tech"
                          />
                        </v-col>
                        <v-col cols="8" class="d-flex flex-column">
                          <gg-text-field
                            class="mt-auto"
                            v-model="model.tech.Phone"
                            required
                            name="Phone"
                            :disabled="!saveButtons.tech"
                          />
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" sm="6" md="8" class="py-0">
                      <v-row no-gutters>
                        <v-col cols="12">
                          <gg-input-label>Fax</gg-input-label>
                        </v-col>
                        <v-col cols="4" class="pr-5">
                          <v-combobox
                            outlined
                            dense
                            name="suffix"
                            autocomplete="suffix"
                            v-model="model.tech_fax_country_code"
                            auto-select-first
                            :items="dialCodes"
                            :disabled="!saveButtons.tech"
                          />
                        </v-col>
                        <v-col cols="8" class="d-flex flex-column">
                          <gg-text-field
                            class="mt-auto"
                            v-model="model.tech.fax"
                            required
                            name="Fax"
                            :disabled="!saveButtons.tech"
                          />
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-form>
              </v-sheet>
            </v-col>
          </gg-card-text>
        </gg-card>
      </v-col>
      <v-col v-show="saveButtons.tech" cols="12">
        <gg-btn
          :loading="buttons.save"
          @click="openLockModal"
        >
          Save
        </gg-btn>
      </v-col>
    </v-row>

    <!--Billing details-->
    <v-row>
      <v-col cols="12">
        <gg-card>
          <gg-card-header>
            <v-row>
              <v-col cols="6">
                Billing Details
              </v-col>
              <v-col cols="6" class="text-right">
                <gg-btn v-show="!saveButtons.billing" @click="saveButtons.billing = true">
                  Edit
                </gg-btn>
              </v-col>
            </v-row>
          </gg-card-header>
          <gg-card-text @input="listenBilling">
            <v-col cols="12" lg="7" xl="5">
              <v-sheet class="pt-3">
                <v-row>
                  <v-col cols="12" sm="6" md="6" class="py-0">
                    <gg-text-field
                      outlined
                      label="First name"
                      v-model="model.billing.FirstName"
                      :disabled="!saveButtons.billing"
                    />
                  </v-col>
                  <v-col cols="12" sm="6" md="6" class="py-0">
                    <gg-text-field
                      outlined
                      label="Last name"
                      v-model="model.billing.LastName"
                      :disabled="!saveButtons.billing"
                    />
                  </v-col>
                  <v-col cols="12" sm="6" md="12" class="py-0">
                    <gg-text-field
                      outlined
                      label="Organization name"
                      v-model="model.billing.OrganizationName"
                      :disabled="!saveButtons.billing"
                    />
                  </v-col>
                  <v-col cols="12" sm="6" md="12" class="py-0">
                    <gg-text-field
                      outlined
                      label="Job title"
                      v-model="model.billing.JobTitle"
                      :disabled="!saveButtons.billing"
                    />
                  </v-col>
                  <v-col cols="12" sm="6" md="12" class="py-0">
                    <gg-text-field
                      outlined
                      label="Email"
                      v-model="model.billing.EmailAddress"
                      :disabled="!saveButtons.billing"
                    />
                  </v-col>
                  <v-col cols="12" sm="6" md="12" class="py-0">
                    <gg-text-field
                      outlined
                      label="Address line 1"
                      v-model="model.billing.Address1"
                      :disabled="!saveButtons.billing"
                    />
                  </v-col>
                  <v-col cols="12" sm="6" md="12" class="py-0">
                    <gg-text-field
                      outlined
                      label="Address line 2"
                      v-model="model.billing.Address2"
                      :disabled="!saveButtons.billing"
                    />
                  </v-col>
                  <v-col cols="12" sm="6" md="4" class="py-0">
                    <gg-text-field
                      outlined
                      label="City"
                      v-model="model.billing.City"
                      :disabled="!saveButtons.billing"
                    />
                  </v-col>
                  <v-col cols="12" sm="6" md="4" class="py-0">
                    <gg-text-field
                      outlined
                      label="State/Province"
                      v-model="model.billing.StateProvince"
                      :disabled="!saveButtons.billing"
                    />
                  </v-col>
                  <v-col cols="12" sm="6" md="4" class="py-0">
                    <gg-text-field
                      outlined
                      label="Zip"
                      v-model="model.billing.PostalCode"
                      :disabled="!saveButtons.billing"
                    />
                  </v-col>
                  <v-col cols="12" sm="6" md="12" class="py-0">
                    <gg-select
                      outlined
                      label="Country"
                      v-model="model.billing.Country"
                      :items="countries"
                      item-text="name"
                      item-value="code"
                      :disabled="!saveButtons.billing"
                    >
                      <template slot="item" slot-scope="{ item }">
                        {{ item.code }} - {{ item.name }}
                      </template>
                      <template slot="selection" slot-scope="{ item }">
                        {{ item.code }} - {{ item.name }}
                      </template>
                    </gg-select>
                  </v-col>
                  <v-col cols="12" md="8" class="py-0">
                    <v-row no-gutters>
                      <v-col cols="12">
                        <gg-input-label>Phone</gg-input-label>
                      </v-col>
                      <v-col cols="4" class="pr-5">
                        <v-combobox
                          outlined
                          dense
                          name="suffix"
                          autocomplete="suffix"
                          v-model="model.billing_country_code"
                          auto-select-first
                          :items="dialCodes"
                          :disabled="!saveButtons.billing"
                        />
                      </v-col>
                      <v-col cols="8" class="d-flex flex-column">
                        <gg-text-field
                          class="mt-auto"
                          v-model="model.billing.Phone"
                          required
                          name="Phone"
                          :disabled="!saveButtons.billing"
                        />
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" md="8" class="py-0">
                    <v-row no-gutters>
                      <v-col cols="12">
                        <gg-input-label>Fax</gg-input-label>
                      </v-col>
                      <v-col cols="4" class="pr-5">
                        <v-combobox
                          outlined
                          dense
                          name="suffix"
                          autocomplete="suffix"
                          v-model="model.billing_fax_country_code"
                          auto-select-first
                          :items="dialCodes"
                          :disabled="!saveButtons.billing"
                        />
                      </v-col>
                      <v-col cols="8" class="d-flex flex-column">
                        <gg-text-field
                          class="mt-auto"
                          v-model="model.billing.fax"
                          required
                          name="Fax"
                          :disabled="!saveButtons.billing"
                        />
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-sheet>
            </v-col>
          </gg-card-text>
        </gg-card>
      </v-col>
      <v-col v-show="saveButtons.billing" cols="12">
        <gg-btn
          :loading="buttons.save"
          @click="openLockModal"
        >
          Save
        </gg-btn>
      </v-col>
    </v-row>

    <lock-modal
      :opened="lockModal"
      :domain="domain.domain"
      @close="closeLockModal"
      @confirm="saveWhois"
    />
  </div>
  <v-row v-else>
    <v-col cols="12">
      <gg-card>
        <gg-card-text>
          <v-alert type="info" dense class="mb-0">
            WHOIS features are not available for this domain TLD.
          </v-alert>
        </gg-card-text>
      </gg-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import amapi from '@/api/amapi'
import { countries } from '@/helpers/countries'
import { deepCopy } from '@/helpers/helpers'
import LockModal from './LockModal'
import domainAttrsMixin from '@/mixins/domainAttributes'

const dialCodes = countries.map(country => country.dial_code).sort((a, b) => a - b)

export default {
  name: 'DomainWhois',
  props: {
    domainid: {
      type: String,
      required: true
    }
  },
  components: { LockModal },
  mixins: [domainAttrsMixin],
  data: () => ({
    dialCodes,
    saveButtons: {
      registrant: false,
      domain: false,
      tech: false,
      billing: false
    },
    model: {
      registrant: {
        PartyID: '',
        FirstName: '',
        LastName: '',
        OrganizationName: '',
        EmailAddress: '',
        Address1: '',
        Address2: '',
        City: '',
        StateProvince: '',
        StateProvinceChoice: '',
        Country: '',
        Phone: '',
        PhoneExt: '',
        Fax: '',
        JobTitle: '',
        PostalCode: '',
      },
      tech: {
        PartyID: '',
        FirstName: '',
        LastName: '',
        OrganizationName: '',
        EmailAddress: '',
        Address1: '',
        Address2: '',
        City: '',
        StateProvince: '',
        StateProvinceChoice: '',
        Country: '',
        Phone: '',
        PhoneExt: '',
        Fax: '',
        JobTitle: '',
        PostalCode: '',
      },
      billing: {
        PartyID: '',
        FirstName: '',
        LastName: '',
        OrganizationName: '',
        EmailAddress: '',
        Address1: '',
        Address2: '',
        City: '',
        StateProvince: '',
        StateProvinceChoice: '',
        Country: '',
        Phone: '',
        PhoneExt: '',
        Fax: '',
        JobTitle: '',
        PostalCode: '',
      },
      registrant_country_code: '',
      tech_country_code: '',
      billing_country_code: '',
      registrant_fax_country_code: '',
      tech_fax_country_code: '',
      billing_fax_country_code: '',
      attributes: {},
      panel: [0],
      isTechActive: false,
      isBillingActive: false,
    },
    attrsVisibility: {},
    extAttributes: null,
    buttons: {
      save: false,
    },
    countries,
    lockModal: false,
  }),
  computed: {
    ...mapGetters(['domain', 'domainPopulated']),
    domainLoaded () {
      return !!Object.keys(this.domain).length
    },
    techLabel () {
      return this.model.isTechActive ? 'Custom' : 'Same as Registrant'
    },
    billingLabel () {
      return this.model.isBillingActive ? 'Custom' : 'Same as Registrant'
    },
    panelInitial () {
      return this.domain.Attributes ? [0, 1] : [0]
    },
    isAttributes () {
      return typeof this.domain.ExtAttributes === 'object' &&
          typeof this.domain.ExtAttributes.Attribute !== 'undefined'
    },
    sortedCountriesList () {
      return countries.sort((a, b) => (a.dial_code > b.dial_code) ? 1 : -1)
    },
    isWhoisAvailable () {
      const tlds = ['io', 'be', 'es']

      return tlds.every(tld => tld !== this.domain.tld)
    }
  },
  watch: {
    domainPopulated () {
      this.parseData()
    },
  },
  mounted () {
    this.$nextTick(() => {
      if (this.domain.load_error) return
      this.parseData()
      this.$nextTick(() => {
        this.conditionalAttributesVisible(this.domain?.ExtAttributes?.Attribute)
        this.test = 'test2'
      })
    })
  },
  methods: {
    ...mapActions(['getDomain', 'reportError', 'reportSuccess']),
    parseData () {
      if (this.domainPopulated && !this.domain.load_error) {
        this.model.registrant = deepCopy(this.domain.contacts.Registrant)
        this.model.tech = deepCopy(this.domain.contacts.Tech)
        this.model.billing = deepCopy(this.domain.contacts.AuxBilling)

        if (this.domain.contacts.Registrant.Phone !== '') {
          let formattedPhone = this.domain.contacts.Registrant.Phone.split(
            '.')

          this.model.registrant_country_code = formattedPhone[0]
          this.model.registrant.Phone = formattedPhone[1]
        }

        if (this.domain.contacts.Tech.Phone !== '') {
          let formattedPhone = this.domain.contacts.Tech.Phone.split('.')

          this.model.tech_country_code = formattedPhone[0]
          this.model.tech.Phone = formattedPhone[1]
        }

        if (this.domain.contacts.AuxBilling.Phone !== '') {
          let formattedPhone = this.domain.contacts.AuxBilling.Phone.split(
            '.')

          this.model.billing_country_code = formattedPhone[0]
          this.model.billing.Phone = formattedPhone[1]
        }

        if (this.domain.contacts.Registrant.Fax !== '') {
          let formattedPhone = this.domain.contacts.Registrant.Fax.split('.')

          this.model.registrant_fax_country_code = formattedPhone[0]
          this.model.registrant.Fax = formattedPhone[1]
        }

        if (this.domain.contacts.Tech.Fax !== '') {
          let formattedPhone = this.domain.contacts.Tech.Fax.split('.')

          this.model.tech_fax_country_code = formattedPhone[0]
          this.model.tech.Fax = formattedPhone[1]
        }

        if (this.isAttributes) {
          // initialise beginning attrs values
          this.model.attributes = this.domain.ExtAttributes.Attribute.reduce(
            (carry, { Name, Options, UserDefined }) => {
              if (this.isEditableAttribute({ Name, Options, UserDefined })) {
                carry[Name] = typeof this.domain.CurrentAttributes[Name] !==
                'undefined' ? this.domain.CurrentAttributes[Name] : ''
              }
              return carry
            }, {})
        }
      }
      this.model.panel = [...this.panelInitial]

      this.show = true
    },
    // storeVocab () { // TODO: delete after final vocab contribution
    //   const storage = window.localStorage
    //   let vocab = {}
    //   if (storage.getItem('vocab')) {
    //     vocab = JSON.parse(storage.getItem('vocab'))
    //   }
    //   console.log(vocab)
    //   const newTerms = this.domain.ExtAttributes.Attribute.reduce((carry, attr) => {
    //     carry[attr.Name] = this.getAttributeLabel(attr)
    //     return carry
    //   }, {})
    //   vocab = {
    //     ...vocab,
    //     ...newTerms
    //   }
    //   storage.setItem('vocab', JSON.stringify(vocab))
    // },
    listenTech (payload) {
      this.model.isTechActive = payload
    },
    listenBilling (payload) {
      this.model.isBillingActive = payload
    },
    computeAttributes () {
      this.conditionalAttributesVisible(this.domain.ExtAttributes.Attribute)
    },
    async saveWhois (bypass_irtp) {
      this.buttons.save = true
      try {
        let registrant = Object.assign({}, this.model.registrant)
        let tech = deepCopy(this.model.tech)
        let billing = deepCopy(this.model.billing)

        if (this.model.registrant.Phone !== '') {
          let code = this.model.registrant_country_code
          let phone = registrant.Phone
          registrant.Phone = `${code}.${phone}`
        }

        if (this.model.tech.Phone !== '') {
          let code = this.model.tech_country_code
          let phone = tech.Phone
          tech.Phone = `${code}.${phone}`
        }

        if (this.model.billing.Phone !== '') {
          let code = this.model.billing_country_code
          let phone = billing.Phone
          billing.Phone = `${code}.${phone}`
        }

        if (this.model.registrant.Fax !== '') {
          let code = this.model.registrant_fax_country_code
          let phone = registrant.Fax
          registrant.Fax = `${code}.${phone}`
        }

        if (this.model.tech.Fax !== '') {
          let code = this.model.tech_fax_country_code
          let phone = tech.Fax
          tech.Fax = `${code}.${phone}`
        }

        if (this.model.billing.Fax !== '') {
          let code = this.model.billing_fax_country_code
          let phone = billing.Fax
          billing.Fax = `${code}.${phone}`
        }

        let data = {
          domain_id: this.domainid,
          Registrant: JSON.stringify(registrant),
          Tech: JSON.stringify(tech),
          AuxBilling: JSON.stringify(billing),
          bypass_irtp
        }
        if (this.isAttributes) {
          const attributes = Object.keys(this.model.attributes)
            .reduce((carry, attrName) => {
              const attr = this.model.attributes[attrName]
              if (typeof attr === 'object' && typeof attr.Value !==
                'undefined') {
                carry[attrName] = attr.Value
              } else {
                carry[attrName] = attr
              }
              return carry
            }, {})
          data = {
            ...data,
            ...attributes,
          }
        }

        const response = await amapi.makecall('domain_whoisupdate', data)
        if (response.result === 'success') {
          this.getDomain(this.domainid)
          this.reportSuccess('Domain WHOIS updated.')
          this.buttons.save = false
        } else {
          this.buttons.save = false
          this.reportError(response.registrar_errors)
        }
      } catch (e) {
        this.buttons.save = false
        this.reportError(e)
      }
    },
    closeLockModal () {
      this.lockModal = false
    },
    async openLockModal () {
      const valid = await this.$validator.validateAll()
      if (!valid) return

      this.lockModal = true
    },
  },
}
</script>
